import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { token, user, loading } = useAuth();

    if (!token) return <Navigate to="/admin/login" replace />;
    if (loading) {
        return (
            <div className="min-h-screen grid place-items-center bg-[#fdfdfd] text-[#52525b] font-mono-tech text-[11px]">
                Verifying session…
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}
